<ng-container *ngIf="!refresh">
  <ion-app>
    <ion-spinner name="lines" *ngIf="dataServ.rData"></ion-spinner>
    <ion-router-outlet id="router-el"></ion-router-outlet>
  </ion-app>
</ng-container>
